import script from "./ReceivedFunding.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceivedFunding.vue?vue&type=script&setup=true&lang=js"

import "./ReceivedFunding.vue?vue&type=style&index=0&id=2164bca7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2164bca7"]])

export default __exports__